import {
  CapitalDeposit,
  CapitalDepositStatus,
  KybDocument,
} from '__generated__/GQL';

import getDraftStatutesStatus from '../../CapitalDepositDraftStatutes/libs/getDraftStatutesModuleStatus';
import { VerificationStatus } from '../../Verification/lib/steps/types';

export enum CapitalDepositQuestionsModuleStatus {
  /**
   * Some module's steps haven't been completed
   */
  ToDo = 'TO_DO',
  /**
   * All the module's steps have been completed
   */
  Complete = 'COMPLETE',
}

type CompanyInput = {
  kybDocuments: Pick<KybDocument, 'type' | 'status'>[];
  capitalDeposit: Pick<CapitalDeposit, 'status'>;
};

const getCapitalDepositQuestionsModuleStatus = (
  company: CompanyInput,
): CapitalDepositQuestionsModuleStatus => {
  const { capitalDeposit } = company;

  if (
    capitalDeposit.status === CapitalDepositStatus.Initiated ||
    getDraftStatutesStatus({
      isCapitalDeposit: true,
      isCompanyCreationSASU: false,
      isMainApplicant: true,
      kybDocuments: company.kybDocuments,
    }) === VerificationStatus.ToDo
  ) {
    return CapitalDepositQuestionsModuleStatus.ToDo;
  }

  return CapitalDepositQuestionsModuleStatus.Complete;
};

export default getCapitalDepositQuestionsModuleStatus;
